// extracted by mini-css-extract-plugin
module.exports = {"container":"filter-option-size_container__2-iDb","name":"filter-option-size_name__OjhbI","checked":"filter-option-size_checked__3LIPF"};